import {
  receiveDVSResult,
} from './actions';
import dataVerificationReducer from './reducer';

export { receiveDVSResult, dataVerificationReducer };
